import {useEffect} from 'react';
import {useSelector} from "react-redux";
import {getGrabTaskResource} from "../../../../data/actions/taskResource";
import LocalStorage from "../../../util/localStorage";
import Resources from "../../../../data/services/resources";
import {getJWT} from "../../../../util/util";

const TaskGrabData = ({
                          dispatch
                      }) => {


    const user = useSelector((state) => state.user)
    const ui = useSelector((state) => state.ui)
    const taskResource = useSelector((state) => state.taskResource)

    const fetchData = () => {
        dispatch(getGrabTaskResource({
            user: LocalStorage.get("user"),
            resource: Resources.DashboardTasks,
            request: 'GET'
        }))
    }

    useEffect(() => {
        // Don't fetch if user is not logged in yet with new token (logging-in page)
        // This will cause it to auto log off
        if (user?.data?.access_token && LocalStorage.has("user"))  {
            fetchData()
        }
    }, [user.data, user.hasUserData])

    useEffect(() => {
        if (!!getJWT().access_token && taskResource.update) {
            fetchData();
        }
    }, [taskResource.update])

    useEffect(() => {
        if (!!getJWT().access_token && ui?.grabUpdate) {
            fetchData()
        }
    }, [ui?.grabUpdate])

    useEffect(() => {
        // Fetch data after creating task from global dialog
        if (!!getJWT().access_token && taskResource.create?.id) {
            fetchData();
        }
    }, [taskResource.create])

    return null
}

export default TaskGrabData;
